const configuration = document.getElementById("gothicrock-component-modules");

if (configuration) {
    const modules = Object.entries(JSON.parse(configuration.textContent)).map(([selector, url]) => ({
        selector,
        url,
        state: "idle"
    }));
    const loadMatching = root => {
        for (const entry of modules) {
            if (entry.state !== "idle") continue;
            if (!root.matches?.(entry.selector) && !root.querySelector?.(entry.selector)) continue;
            entry.state = "loading";
            import(entry.url).then(() => {
                entry.state = "loaded";
                if (modules.every(module => module.state === "loaded")) observer.disconnect();
            }).catch(error => {
                entry.state = "idle";
                console.error("Theme component could not load", entry.url, error);
            });
        }
    };
    const observer = new MutationObserver(records => {
        for (const record of records) {
            for (const node of record.addedNodes) {
                if (node.nodeType === 1) loadMatching(node);
            }
        }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    loadMatching(document);
}
